/** @jsx React.DOM */
var React = require('react/addons')
var formatters = require('../helpers/formatters')
var cx = React.addons.classSet

var DropdownButton = React.createClass({displayName: 'DropdownButton',
  onClick: function(value, e) {
    e.preventDefault()
    this.props.onChange(value)
  },

  render: function() {
    return React.DOM.div({className: "btn-group"}, 
      React.DOM.button({type: "submit", className: "btn", disabled: this.props.disabled ? 'disabled': ''}, 
        "Search"
      )
    )
  }
})

var Search = React.createClass({displayName: 'Search',
  mixins: [React.addons.LinkedStateMixin],

  getInitialState: function() {
    return {
      value: '',
      invalid: false,
      loading: false
    }
  },

  onSubmit: function(e) {
    e.preventDefault()

    this.setState({ invalid: false })

    if (formatters.isRippleAccountId(this.state.value)) {
        window.location.hash = '#/rmc/accounts/' + this.state.value
        this.setState({ value: '' })
        return
    }

    if (formatters.isTransactionHash(this.state.value)) {
        window.location.hash = '#/rmc/transactions/' + this.state.value
        this.setState({ value: '' })
        return
    }

    this.setState({ invalid: true })
  },

  render: function() {
    return React.DOM.form({className: "navbar-form navbar-right nav-right", role: "search", onSubmit: this.onSubmit}, 
      React.DOM.div({className: cx({ 'form-group': true, 'has-error': this.state.invalid })}, 
        React.DOM.input({type: "text", className: "form-control", valueLink: this.linkState('value')})
      ), 
      DropdownButton({value: "Search", disabled: this.state.loading})
    )
  }
})


module.exports = Search



//////////////////
// WEBPACK FOOTER
// ./src/partials/search.jsx
// module id = 220
// module chunks = 0